import { defineComponent as _defineComponent } from 'vue'
import { YMPush } from "@/uitls/uitls";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { userScoreList } from "@/api/php/me";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  name: 'IntegralDetail',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n();
const router = useRouter();
onMounted(() => {
  getData()
});

const score = ref(0)
const list = ref([])
const getData = async () => {
  const res: any = await userScoreList()
  console.log(res);
  if (res && res.code == 200) {
    score.value = res.data.score
    list.value = res.data.list
  }

}

onMounted(() => {
  YMPush('MAIN', 'IntegralDetail');
});

const __returned__ = { t, router, score, list, getData }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})